import { components } from 'react-select';

const CustomSingleSelect = (props: any) => {
    const { data } = props;
    return (
        <components.SingleValue {...props}>
            {data.selectLabel || data.label}
        </components.SingleValue>
    );
};
export default CustomSingleSelect;